import React from "react";

const ProcessingBarSmall = () => {
  return (
    <>
      <span className="loader" />
      <style>{`
        .loader {
          width: 7px;
          height: 7px;
          border-radius: 50%;
          display: block;
          margin: 5px auto;
          position: relative;
          animation: shadowPulse 1s linear infinite;
        }

        @keyframes shadowPulse {
          33% {
            background: #FFF;
            box-shadow: -12px 0 #991b1b, 12px 0 #FFF;
          }
          66% {
            background: #fff;
            box-shadow: -12px 0 #991b1b, 12px 0 #FFF;
          }
          100% {
            background: #FFF;
            box-shadow: -12px 0 #FFF, 12px 0 #991b1b;
          }
        }
      `}</style>
    </>
  );
};

export default ProcessingBarSmall;
